import { GlobalProvider } from "./context/GlobalProvider";
import Routing from "./routes/Routing";
import 'react-quill/dist/quill.snow.css';
// import 'antd/dist/antd.css';

function App() {
  return (
    <GlobalProvider>
      <Routing />
    </GlobalProvider>
  )
}

export default App; 
